import * as React from 'react';
import './style.scss'
import { Link } from 'react-router-dom'

export interface IHeaderProps {
  current?: string,
}

export interface IHeaderStates {
  navStatus: boolean,
}

export default class Header extends React.Component<IHeaderProps, IHeaderStates> {
  constructor(props: IHeaderProps) {
    super(props)
    this.state = {
      navStatus: false
    }
    this.changeNavStatus = this.changeNavStatus.bind(this);
  }

  public componentDidMount() {
    const mobile = sessionStorage.getItem('mobile') === 'true' ? true : false
    if (!mobile) {
      location.href = '/'
    }
  }

  public handleClick(index: number) {
    switch (index) {
      case 1:
        location.href = '/mobileHome'
        break;
      case 2:
        this.scrollTo('ourGame')
        break;
      case 3:
        this.scrollTo('news')
        break;
      case 4:
        this.scrollTo('ourGame')
        break;
      case 5:
        this.scrollTo('ourGame')
        break;
      default:
        break;
    }
    this.setState({ navStatus: false });
  }

  public scrollTo(id: string) {
    const anchorElement = document.getElementById(id);
    if (anchorElement) {
      window.scrollTo({ top: anchorElement.offsetTop - 60, behavior: "smooth" });
    }
  }

  public changeNavStatus(navStatus: boolean) {
    this.setState({ navStatus });
  }

  public render() {
    return (
      <div className="header-mobile">
        <div className="first-content">
          <img onClick={this.changeNavStatus.bind(this, true)} className="menu-style" src={require("@static/menu.png")} alt="域起官网" />
          <img className="logo-style" src={require("@static/logo.png")} alt="域起官网" />
          <div className="visibility-hidden"> <img className="change-style" src={require("@static/change.png")} alt="域起官网" /> <span>EN</span></div>
        </div>
        {
          this.state.navStatus ? (<div className="shadow-screen" onClick={this.changeNavStatus.bind(this, false)} />) : ''
        }
        <div className={`left-nav ${this.state.navStatus ? 'open-nav' : ''}`}>
          <img className="close-icon" onClick={this.changeNavStatus.bind(this, false)} src={require("@static/close.png")} alt="域起官网" />
          <div onClick={this.handleClick.bind(this, 1)}>首页</div>
          {this.props.current === 'mobileHome'
            ? (
              <React.Fragment>
                <div onClick={this.handleClick.bind(this, 2)}>游戏产品</div>
                <div onClick={this.handleClick.bind(this, 3)}>新闻资讯</div>
              </React.Fragment>)
            : (
              <React.Fragment>
                <div><Link to={{ pathname: `/mobileHome`, state: { location: 'game' } }}>游戏产品</Link></div>
                <div><Link to={{ pathname: `/mobileNews` }}>新闻资讯</Link></div>
              </React.Fragment>)}
          <div><Link to={{ pathname: `/mobileAboutUs` }}>关于我们</Link></div>
          <div><Link to={{ pathname: `/mobileJoinUs` }}>加入我们</Link></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Mobile/Header/index.tsx